const PRODUCT_CODES = {
  PRODUCTS: 'PRODUCT_CODES_PRODUCTS'
};

export default PRODUCT_CODES;



// WEBPACK FOOTER //
// ./src/constants/productCodes.js